import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import { Mail } from 'lucide-react';
import { useDPSRoute } from '../hooks/useDPSRoute';
import { useDeviceSize } from '../hooks/useMediaQuery';
import { useWhiteLabel } from '../hooks/useWhiteLabel';

interface LayoutProps {
  children: ReactNode;
}

function Layout({ children }: LayoutProps) {
  useDPSRoute();
  const location = useLocation();
  const { isMobile } = useDeviceSize();
  const { appName, contactEmail, isCustomBrand } = useWhiteLabel();
  const isDPSRoute = location.pathname.startsWith('/dps/report/');

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main style={{ paddingTop: isDPSRoute ? 0 : isMobile ? '56px' : '64px' }}>
        {children}
      </main>
      {!isDPSRoute && (
        <footer className="bg-gray-900 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <h3 className="text-lg font-semibold mb-4">{appName}</h3>
                <p className="text-gray-400">
                  Votre partenaire de confiance pour la sécurité de votre logement.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Contact</h3>
                <p className="text-gray-400 flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  Email:{' '}
                  <a
                    href={`mailto:${contactEmail}`}
                    className="hover:text-blue-400 transition-colors underline"
                  >
                    {contactEmail}
                  </a>
                </p>
              </div>
              {!isCustomBrand && (
                <div>
                  <h3 className="text-lg font-semibold mb-4">Liens utiles</h3>
                  <ul className="space-y-2 text-gray-400">
                    <li>
                      <Link to="/mentions-legales" className="hover:text-white transition-colors">
                        Mentions légales
                      </Link>
                    </li>
                    <li>
                      <Link to="/politique-confidentialite" className="hover:text-white transition-colors">
                        Politique de confidentialité
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400">
              <p>&copy; {new Date().getFullYear()} {appName}. Tous droits réservés.</p>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
}

export default Layout;
